import { create } from 'zustand';
import { readLS, writeLS } from '@/services/storage/local';

export type ThemeMode = 'light' | 'dark';
export type Density = 'comfortable' | 'compact';

type ThemeState = {
  theme: ThemeMode;
  density: Density;
  setTheme: (t: ThemeMode) => void;
  setDensity: (d: Density) => void;
  toggleTheme: () => void;
};

const THEME_KEY = 'canapyra-theme';
const DENSITY_KEY = 'canapyra-density';

const apply = (theme: ThemeMode, density: Density) => {
  const html = document.documentElement;
  html.setAttribute('data-theme', theme);
  html.setAttribute('data-density', density);
};

export const useThemeStore = create<ThemeState>((set, get) => {
  const theme = readLS<ThemeMode>(THEME_KEY, 'light');
  const density = readLS<Density>(DENSITY_KEY, 'comfortable');
  if (typeof document !== 'undefined') apply(theme, density);
  return {
    theme,
    density,
    setTheme: (t) => {
      apply(t, get().density);
      writeLS(THEME_KEY, t);
      set({ theme: t });
    },
    setDensity: (d) => {
      apply(get().theme, d);
      writeLS(DENSITY_KEY, d);
      set({ density: d });
    },
    toggleTheme: () => {
      const next: ThemeMode = get().theme === 'light' ? 'dark' : 'light';
      apply(next, get().density);
      writeLS(THEME_KEY, next);
      set({ theme: next });
    },
  };
});
